<template>
  <div class="Auth">
    <router-view v-if="isLogin"/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const authHelper = createNamespacedHelpers('auth')
export default {
  name: 'Auth',
  data () {
    return {}
  },
  computed: {
    ...authHelper.mapGetters(['isLogin', 'haveAnyPermission'])
  },
  async created () {
    // 该框架无法从查询参数中拿token
    await this.extractLocalAuthInfoThenAuth({})
    if (!this.isLogin) {
      this.authInvalid()
    } else if (!this.haveAnyPermission) {
      this.authInvalid()
      this.$message.error('没有菜单权限')
    }
  },
  methods: {
    ...authHelper.mapActions(['extractLocalAuthInfoThenAuth', 'authInvalid'])
  }
}
</script>

<style scoped lang="scss">
  .Auth{

  }
</style>



// WEBPACK FOOTER //
// src/views/Auth/index.vue